import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import { getSanityImg } from 'src/sanityClient';
import { LazyLoadImage, LazyLoadSource } from 'ck-ui';
import { getPromoName, trackPromotionClick } from '../utils';
import { usePromotionView } from '../hooks';
import styles from './AppDownload.module.scss';

const AppDownload = ({ blockAppDownload, position, handle }) => {
  const { desktopImage, mobileImage, title, appleDownloadLink, googleDownloadLink, trackingID } = blockAppDownload;
  const ref = React.useRef(null);
  const isMobile = useMedia('(max-width: 767px)');
  const desktopImgUrl = getSanityImg(desktopImage).auto('format').url();
  const mobileImgUrl = getSanityImg(mobileImage).auto('format').url();

  const applePromo = {
    id: handle,
    name: getPromoName(handle, trackingID ? `${trackingID} -> Apple Download` : 'Apple Download'),
    creative: isMobile ? mobileImgUrl : desktopImgUrl,
    position: `${handle}-${position}-1`
  };

  const androidPromo = {
    id: handle,
    name: getPromoName(handle, trackingID ? `${trackingID} -> Android Download` : 'Android Download'),
    creative: isMobile ? mobileImgUrl : desktopImgUrl,
    position: `${handle}-${position}-2`
  };

  usePromotionView([applePromo, androidPromo], ref);

  return (
    <section ref={ref} className="home-section">
      <div className="container">
        <div className="columns">
          <div className="column">
            <div className="is-relative">
              <div className="home-promo-single image-wrapper">
                <picture>
                  <LazyLoadSource
                    media="(max-width: 1087px)"
                    srcSet={mobileImgUrl}
                  />
                  <LazyLoadSource
                    media="(min-width: 1088px)"
                    srcSet={desktopImgUrl}
                  />
                  <LazyLoadImage
                    src={desktopImgUrl}
                    alt={title || 'Download App'}
                  />
                </picture>
              </div>
              <div className={`${styles.buttons} is-hidden-desktop`}>
                <a
                  href={appleDownloadLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  title="Culture Kings iOS App Download Link"
                  onClick={() => trackPromotionClick(applePromo)}
                >
                  <LazyLoadImage
                    src="https://cdn.shopify.com/s/files/1/1023/3455/files/apple_app_icon.svg?v=1621475748"
                    alt="iOS App Download Icon"
                  />
                </a>
                <a
                  href={googleDownloadLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  title="Culture Kings Android App Download Link"
                  onClick={() => trackPromotionClick(androidPromo)}
                >
                  <LazyLoadImage
                    src="https://cdn.shopify.com/s/files/1/1023/3455/files/google_app_icon.svg?v=1621475883"
                    alt="Android App Download Icon"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

AppDownload.propTypes = {
  blockAppDownload: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired
};

export { AppDownload };
